/**
 * bell_haptic_controller.js — subtle haptic when the notification bell opens.
 *
 * Attached to the bell toggle (data-controller="bell-haptic"). Fires on Bootstrap's
 * show.bs.dropdown so the buzz lands on the same tap that opens the dropdown and
 * triggers the icon jingle. Routes through the window.ChippieBridge facade, which
 * owns per-runtime transport (iOS Strada / Android ChippieNative / PWA vibrate).
 * A no-op on desktop, so it's harmless there.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this._onShow = () => {
            if (window.ChippieBridge && window.ChippieBridge.haptic) {
                try { window.ChippieBridge.haptic(); } catch (_e) { /* facade gone */ }
            }
        };
        this.element.addEventListener('show.bs.dropdown', this._onShow);
    }

    disconnect() {
        if (this._onShow) {
            this.element.removeEventListener('show.bs.dropdown', this._onShow);
            this._onShow = null;
        }
    }
}
